/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import Vue from 'vue'
import { store } from '../store'

export const actions = {
    changeTripId({commit}, payload) {
        commit('setTripId', payload.tripId)
    },
    async getTripDetails({commit}, payload) {

        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        Vue.http.get(`api/trip/${ payload.tripId }`)
            .then(response => {
                commit('setTripDetails', response.body.data)
            })
            .catch(err => {
                console.log(err)
            })
    },
    async getTruckInformation({commit}, payload) {
        Vue.http.options.root = process.env.VUE_APP_HOST_LOCATION_SERVICE_BASEURL
        Vue.http.headers.common['x-api-key'] = process.env.VUE_APP_HOST_LOCATION_SERVICE_KEY
        Vue.http.get('v1/truck-position', {params: {truck: payload.truckId}})
            .then(response => {
                commit('setTruckInformation', response.body)
            })
            .catch(err => {
                console.log(err)
            })
    },
    async getTrailerInformation({commit}, payload) {
        Vue.http.options.root = process.env.VUE_APP_HOST_LOCATION_SERVICE_BASEURL
        Vue.http.headers.common['x-api-key'] = process.env.VUE_APP_HOST_LOCATION_SERVICE_KEY
        Vue.http.get('v1/truck-position', {params: {truck: payload.trailerId}})
            .then(response => {
                commit('setTrailerInformation', response.body)
            })
            .catch(err => {
                console.log(err)
            })
    },
    async getTripRoutePath({commit}, payload) {
        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })
        Vue.http.get('api/trip/route/path', {params: {tripId: payload.tripId}})
            .then(response => {
                commit('setRoutePath', response.body.data)
            })
            .catch(err => {
                console.log(err)
            })
    },
    async getDriverActivity({commit}, payload) {

        return new Promise((resolve, reject) => {

        // Setup connection with backend
        store.dispatch('userModule/loadClientsBackConnection', { root: true })

        Vue.http.get(`api/trip/status/${payload.tripId}`)
            .then(response => {
                commit('setDriverActivity', response.body.data)
                resolve(response.body)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    async getTripFile({commit}, payload) {

        return new Promise( async (resolve, reject) => {

            // Setup connection with backend
            store.dispatch('userModule/loadClientsBackConnection', { root: true })

            await Vue.http.get(`api/trip/${ payload.tripId }/file/${ payload.fileType }`, {responseType: 'arraybuffer'})
                .then(response => {
                    let blob = new Blob([response.body], { type:response.headers.get('content-type') });
                    resolve(blob)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    async getTimeInformation({commit}, payload) {

    },
    async getRouteInformation({commit}, payload) {
        
    },
    getSealChanges({commit}, payload) {

        store.dispatch('UI/loaders/changeSealChangesLoader', true, { root: true })

        return new Promise( async (resolve, reject) => {

            // Setup connection with backend
            store.dispatch('userModule/loadClientsBackConnection', { root: true })

            await Vue.http.get(`api/sealChanges/trip/${payload.tripId}`)
                .then(response => {
                    commit('setSealChanges', response.body.data)
                    store.dispatch('UI/loaders/changeSealChangesLoader', false, { root: true })
                    resolve(response.body)
                })
                .catch(err => {
                    store.dispatch('UI/loaders/changeSealChangesLoader', false, { root: true })
                    reject(err)
                })
        })

    },
    destroyTruckInformation({commit}, payload) {
        commit('setTruckInformation', null)
    },
    destroyTrailerInformation({commit}, payload) {
        commit('setTrailerInformation', null)
    },
    destroyDriverActivity({commit}, payload) {
        commit('setDriverActivity', null)
    },
    destroyTripRoutePath({commit}, payload) {
        commit('setRoutePath', null)
    },
    destroySealChanges({commit}, payload) {
        commit('setSealChanges', [])
    } 
}